'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.default = getCheckoutUrl;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _buildRechargeCheckoutUrl = require('./buildRechargeCheckoutUrl');

var _buildRechargeCheckoutUrl2 = _interopRequireDefault(_buildRechargeCheckoutUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get Checkout URL
 *
 * @return  string   checkoutUrl - The checkout url to Shopify's normal checkout or ReCharges custom checkout.
 */

function getCheckoutUrl() {
  var _this = this;

  return new Promise(function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(resolve, reject) {
      var cartResponse, cartHasSubscriptionProduct, cartToken, rechargeUrl;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios2.default.get('/cart.js');

            case 2:
              cartResponse = _context.sent;


              // Check if the cart has a recharge subscription product.
              cartHasSubscriptionProduct = cartResponse.data.items.some(function (item) {
                if (item.properties) {
                  return item.properties.subscription_id;
                } else {
                  return false;
                }
              });

              // If the cart has a subscription product then build the url.

              if (cartHasSubscriptionProduct) {
                cartToken = cartResponse.data.token;
                rechargeUrl = (0, _buildRechargeCheckoutUrl2.default)(cartToken);

                resolve(rechargeUrl);
              }
              // Else return the standard Shopify checkout URL.
              else {
                  resolve(window.theme.shopifySecureUrl + '/checkout');
                }

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}